import { Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CircleIcon from '@mui/icons-material/Circle'
import { availableToColor } from 'pages/Supervision/helpers'

const TAB_STATUS = ['up', 'degraded', 'down']

const MapLegend = () => {
  const { t } = useTranslation()

  return (
    <Paper sx={{ 
      px: 2, 
      py: 1.5, 
      display: 'flex',
      borderRadius: '24px'
    }}>
      <Stack direction="row" gap={1}>
        {TAB_STATUS.map((s) => {
          return (
            <Stack key={s} direction="row" alignItems="center" gap={0.5}>
              <CircleIcon
                sx={{ color: availableToColor(s), fontSize: '10px' }}
              />
              <Typography sx={{ fontSize: '10px', lineHeight: '16px', fontWeight: '400', color: 'content.primary' }}>
                {t(`cartography.maps.legend.${s}`)}
              </Typography>
            </Stack>
          )
        })}
      </Stack>
    </Paper>
  )
}

export default MapLegend
